import { NewTypeahead, NewInput, Typeahead } from '@carta/ink';
import * as React from 'react';
export default {
  NewTypeahead,
  NewInput,
  Typeahead,
  React
};